import React, { useEffect, useState } from "react";
import { DataStore } from "aws-amplify";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import {  DatePicker, Select } from "../components/ui";

import {
    Button,
    Card,
    Flex,
    Grid,
    SelectField,
    TextField,
  } from "@aws-amplify/ui-react";


import { Vitals } from "../models";

import '../App.css';

const VitalsHistory = ({ userEmail }) => {
  const today = new Date();
  
  // Default: Show last 7 days or 30 days
  const defaultDays = 7; // Change to 30 for one month
  const lastWeek = new Date();
  lastWeek.setDate(today.getDate() - defaultDays);

  // State for date range
  const [startDate, setStartDate] = useState(lastWeek);
  const [endDate, setEndDate] = useState(today);
  const [selectedVital, setSelectedVital] = useState("all");
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (userEmail) {
      fetchVitalsHistory(userEmail);
    }
  }, [userEmail, startDate, endDate]);

  const fetchVitalsHistoryOld = async (email) => {
    try {
      let records = await DataStore.query(Vitals, (c) => c.userEmail.eq(email));

      // Convert AWSDateTime to timestamp and filter
      const start = Date.parse(startDate);
      const end = Date.parse(endDate);
      
      records = records.filter((item) => {
        const itemTimestamp = Date.parse(item.timestamp);
        return itemTimestamp >= start && itemTimestamp <= end;
      });

      setHistory(records);
    } catch (error) {
      console.error("❌ Error fetching vitals:", error);
    }
  };


  const fetchVitalsHistory = async (email) => {
   // console.log("@fetchVitalsHistory userEmail:", email);
  
    try {
      await DataStore.start(); // Ensure sync without clearing cache
    
      let records = await DataStore.query(Vitals, (c) => c.userEmail.eq(email));
     // console.log("Raw records from DataStore:", records);
  
      if (records.length === 0) {
        console.warn("⚠️ No records found for this user.");
        setHistory([]); // Clear graph if no data
        return;
      }
  
      // Ensure startDate and endDate are Date objects
      const start = startDate instanceof Date ? new Date(startDate) : new Date(startDate);
      start.setUTCHours(0, 0, 0, 0);
  
      const end = endDate instanceof Date ? new Date(endDate) : new Date(endDate);
      end.setUTCHours(23, 59, 59, 999);
  
    //  console.log(`Filtering from ${start.toISOString()} to ${end.toISOString()}`);
  
      // Ensure filtering is done correctly
      records = records.filter((item) => {
        if (!item.timestamp) return false; // Ignore records without timestamp
  
        const itemTimestamp = new Date(item.timestamp).getTime();
        return itemTimestamp >= start.getTime() && itemTimestamp <= end.getTime();
      });
  
    //  console.log("Filtered records:", records);
  
      setHistory(records); // Update state
    } catch (error) {
      console.error("❌ Error fetching vitals:", error);
    }
  };
  

  return (
    <Card className="p-4 mt-6">
      <h2 className="text-xl font-semibold">Vitals History</h2>
      <div className="flex gap-4 mb-4">
        {/* Ensure DatePicker Displays Default Dates */}
        <DatePicker 
          selected={startDate} 
          onChange={(date) => setStartDate(date || today)} 
          dateFormat="yyyy-MM-dd"
          placeholderText="Select Start Date"
        />
        <DatePicker 
          selected={endDate} 
          onChange={(date) => setEndDate(date || today)} 
          dateFormat="yyyy-MM-dd"
          placeholderText="Select End Date"
        />
        
        <Select value={selectedVital} onChange={(e) => setSelectedVital(e.target.value)}>
          <option value="all">All Vitals</option>
          <option value="hr">Heart Rate</option>
          <option value="spo2">SpO2</option>
          <option value="rr">Respiratory Rate</option>
          <option value="bp">Blood Pressure</option>
        </Select>
        <Button onClick={() => fetchVitalsHistory(userEmail)} className="start-scan-btn" >Filter</Button>
      </div>

      <LineChart width={600} height={300} data={history}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="timestamp" />
        <YAxis />
        <Tooltip />
        <Legend />
        {(selectedVital === "all" || selectedVital === "hr") && <Line type="monotone" dataKey="hr" stroke="#8884d8" name="HR" />}
        {(selectedVital === "all" || selectedVital === "spo2") && <Line type="monotone" dataKey="spo2" stroke="#82ca9d" name="SpO2" />}
        {(selectedVital === "all" || selectedVital === "rr") && <Line type="monotone" dataKey="rr" stroke="#ff7300" name="RR" />}
        {(selectedVital === "all" || selectedVital === "bp") && <Line type="monotone" dataKey="bp" stroke="#ff0000" name="BP" />}
      </LineChart>
    </Card>
  );
};

export default VitalsHistory;